import { useToastStore } from '../store/toastStore';

export function ToastHost() {
  const message = useToastStore((s) => s.message);
  const variant = useToastStore((s) => s.variant);
  const hide = useToastStore((s) => s.hide);

  if (!message) return null;

  return (
    <div className="app-toast-host" role="status" aria-live="polite">
      <div
        className={`app-toast app-toast--${variant}`}
        onClick={hide}
      >
        <span className="app-toast__icon" aria-hidden>
          {variant === 'success' ? '✓' : '!'}
        </span>
        <span className="app-toast__text">{message}</span>
      </div>
    </div>
  );
}
